import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { store } from "Store";
import { useNavigate, useParams } from "react-router-dom";
import { validateToken } from "./ResetPasswordAxiosFuncs";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import ResetPasswordVerifyMFA from "./Component/ResetPasswordVerifyMFA";
import ResetPasswordSetupMFA from "./Component/ResetPasswordSetupMFA";
import { PATHS } from "Utils/PagePaths";

const ResetPasswordMFA = () => {

  const { token } = useParams();
  const loginState = store.getState().loginInfo;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forwardPage, setForwardPage] = useState(0);


  // init load to validate the token in the URL from the email
  const initLoad = async (token) => {
    // the Reset Password MFA can only be operated when the user is not login!
    if (loginState.token) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.GENERAL_ERROR.title,
          msg: "Please sign out to reset password.",
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      });

      return;
    }

    const res = await validateToken(token)
      .catch(function (error) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        return error.response;
      });

    //console.log("initLoad() reset password", res);
    if (res && res.data?.status !== 1) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: res.data.globalErrorMessageList,
          showContactHelp: false
        },
        redirect: {
          redirect: true,
          redirectFirst: true,
          path: PATHS.public['Sign In'],
          data: {}
        }
      });
      return;
    }
    if (res && res.data?.status === 1) {

      if (res.data.data?.forwardPage === 1) {
        navigate("/password/token/" + token + "/2", { state: { isForward: true } });
      } else {
        setForwardPage(res.data.data?.forwardPage);
      }
    }
  }

  // init
  useEffect(() => {
    initLoad(token);
  }, []);

  return (
    <>
      {forwardPage === 3 ?
        <ResetPasswordVerifyMFA></ResetPasswordVerifyMFA>
        : null
      }
      {forwardPage === 2 ?
        <ResetPasswordSetupMFA></ResetPasswordSetupMFA>
        : null
      }
    </>
  )
}

export default ResetPasswordMFA;